export class routesdto {
    routetypesid: string | undefined;
    usercreated: string | undefined;
    datecreated: string | undefined;
    userupdated: string | undefined;
    dateupdated: string | undefined;
    deletedyn: boolean | false;
    routetypeid: number | undefined;
    routetype: string | undefined;
    rolefromid: number | undefined;
    rolefrom: string | undefined;
    roletoid: number | undefined;
    roleto: string | undefined;
    tostatusid: number | undefined;
    tostatus: string | undefined;
    actionid: number | undefined;
    action: string | undefined;
    priority: number | undefined;
    externalrouteyn: boolean | undefined;
}